import { ToastAlertTypes } from '@genial/components';
import { ResponsesSubscriptionMarketStatusResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

export const getSubscriptionMarketClosedMessage = (
  data: ResponsesSubscriptionMarketStatusResponse | undefined
) => {
  if (!data) {
    return '';
  }

  if (data.market.isOpened) {
    return '';
  }

  const initialTime = Utils.Mask.DateFormat(data?.market.openingTime, 'HH');
  const finalTime = Utils.Mask.DateFormat(data?.market.closingTime, 'HH');

  return `Esta ação está disponível apenas \nno período de ${initialTime}h às ${finalTime}h.`;
};

export const defaultErrorMessageSubscription: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao enviar a boleta, verifique sua conexão com a internet e tente novamente em instantes.',
];
